<template>
  <el-dialog v-dialogDrag v-loading="loading" :title="title" :visible.sync="dlgVisible" :close-on-click-modal="false"
    :close-on-press-escape="false" width="800px">
    <div>
      <ctrl ref="ctrl" />
      <div v-if="showBotton" class="check">
        <el-button size="small" type="primary" @click="queryApproveNodes"> 查询处理人设置 </el-button>
      </div>
      <flowNodesEditor v-show="flowNodesEditorVisible" ref="flowNodesEditor" :flow-key="params.flowKey"
        :flow-version-id="params.currentVersionId" />
    </div>
    <div slot="footer">
      <el-button type="primary" :disabled="!showStartButtons" size="small" @click="handleSubmit">提交申请</el-button>
      <el-button type="default" size="small" @click="dlgVisible = false">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import ctrl from "./index";
import flowNodesEditor from "@/CommonDP/pages/components/launchFlow/components/flowNodesEditor";
import leaveService from "@/CommonDP/service/leave-service";

export default {
  components: { ctrl, flowNodesEditor },
  data() {
    return {
      title: "请假申请",
      loading: false,
      dlgVisible: false,
      params: {},
      showBotton: false,
      flowNodesEditorVisible: false,
      showStartButtons: false,
      isRestart: false
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId,
      prjInfo: state => state.projectMg.prjObj
    })
  },
  methods: {
    // 接口：约定给框架提供的方法
    openForStart(params) {
      console.debug(params);
      this.params = params;
      this.reset();
      this.showBotton = true;
      this.dlgVisible = true;
    },
    // 接口：约定给框架提供的方法
    openForRestart(params) {
      console.debug(params);
      this.reset();
      this.title = "请假申请（重新发起 ）";
      this.params = params;
      this.isRestart = params.viewParam === "restart";
      this.showBotton = true;
      this.dlgVisible = true;
      this.$nextTick(() => this.queryDetail(params));
    },

    reset() {
      this.title = "请假申请";
      this.loading = false;
      this.dlgVisible = false;
      this.showBotton = false;
      this.flowNodesEditorVisible = false;
      this.showStartButtons = false;
      this.isRestart = false;
    },

    async queryDetail(params) {
      const res = await leaveService.queryDetail(params.flowInstanceId);
      const data = res.data || {};
      this.$refs.ctrl.setFormData(data.businessData || {});
    },

    // 查询处理人设置
    async queryApproveNodes() {
      const success = await this.validateBeforeQueryNodes();
      if (success) {
        this.flowNodesEditorVisible = true;
        this.queryFlowNodes();
      }
    },

    async validateBeforeQueryNodes() {
      return await this.$refs.ctrl.validate();
    },

    async queryFlowNodes() {
      const formData = this.$refs.ctrl.getFormData();
      const prjId = this.params.prjId || this.prjInfo.prjId;
      const success = await this.$refs.flowNodesEditor.queryFlowNodes(formData, prjId);
      if (success) {
        this.showStartButtons = true;
      }
    },

    async validateBeforeSubmit() {
      let success = await this.$refs.ctrl.validate();
      if (!success) {
        return false;
      }
      success = await this.$refs.flowNodesEditor.validate();
      if (!success) {
        return false;
      }
      return true;
    },

    async handleSubmit() {
      const success = await this.validateBeforeSubmit();
      if (!success) {
        return;
      }
      this.showStartButtons = false;
      this.loading = true;
      try {
        const json = this.makeSubmitParams();
        if (this.isRestart) {
          await leaveService.restartApply(json);
          this.$success("重新发起成功，请到我发起的流程中查看");
          this.$emit("refreshList");
        } else {
          await leaveService.startApply(json);
          this.$success("申请成功，请到我发起的流程中查看");
          this.$emit("refreshList");
        }
        this.dlgVisible = false;
      } catch (error) {
        this.showStartButtons = true;
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    makeSubmitParams() {
      const json = this.$refs.ctrl.getFormData();
      console.debug("json........", json);
      return {
        ...json,
        flowInstanceId: this.params.flowInstanceId || "",
        flowDefinitionId: this.params.flowDefinitionId,
        flowKey: this.params.flowKey,
        prjId: this.params.prjId || this.prjInfo.prjId,
        enterpriseId: this.enterpriseId,
        flowNodeDtoList: this.$refs.flowNodesEditor.getFlowNodeWithAddedUsers(),
        ccUserIdList: this.$refs.flowNodesEditor.expose_getCCUserIdList()
      };
    }
  }
};
</script>

<style></style>
